<template>
	<div class="flex">
		<div v-if="false" class="mgs-hole-edit-container w-1/2 mr-2">
			<h2 class="m-0 text-center">{{ hole.hole }}</h2>
			<button
				class="mgs-previous-hole button mgs-button is-small"
				@click="$emit('go-to-previous-hole')"
			>
				< Previous
			</button>
			<div class="mgs-hole-edit flex items-center ml-auto">
				<div>Score</div>
				<div :class="scoreClasses(hole)" class="text-center">
					{{ hole.score }}
					<input
						ref="score"
						@input="updateScore(hole)"
						class="mgs-scorecard-input"
						maxlength="2"
						type="hidden"
						min="0"
						v-model="hole.score"
						readonly
					/>
				</div>
			</div>
			<div class="mgs-hole-edit flex items-center" v-if="hole.par > 3">
				<div>Fairway</div>
				<course-fairway-select :course-hole="hole"></course-fairway-select>
			</div>
			<div class="mgs-hole-edit flex items-center">
				<div>GIR</div>
				<div class="font-bold text-center" :class="{ 'text-red-600': !!!hole.gir }">
					<template v-if="hole.score > 0">
						<template v-if="!!hole.gir">&#10003;</template>
						<template v-else>&#10007;</template>
					</template>
				</div>
			</div>
			<div class="mgs-hole-edit flex text-center">
				<div>Putts</div>
				<div>
					<template v-if="hole.score > 0">
						{{ hole.putts }}
						<input
							@input="updateScore(hole)"
							class="mgs-scorecard-input"
							maxlength="2"
							type="hidden"
							min="0"
							v-model="hole.putts"
							readonly
						/>
					</template>
				</div>
			</div>
			<div v-if="!hole.gir && hole.score" class="mgs-hole-edit flex items-center">
				<div>Scrambles</div>
				<div
					class="font-bold text-center"
					:class="{ 'text-red-600': !hole.gir && hole.score > hole.par }"
				>
					<template >
						<template v-if="hole.score <= hole.par">&#10003;</template>
						<template v-else>&#10007;</template>
					</template>
				</div>
			</div>
			<div v-if="!hole.gir && hole.score" class="mgs-hole-edit flex items-center">
				<div>Method</div>
				<course-scramble-select
					v-show="!!!hole.gir && hole.score"
					:course-hole="hole"
				></course-scramble-select>
			</div>
			<div class="mgs-hole-edit flex items-center">
				<div>Penalties</div>
				<div>
					<input
						@input="updateScore(hole)"
						class="mgs-scorecard-input"
						maxlength="2"
						type="number"
						min="0"
						v-model="hole.penalties"
					/>
				</div>
			</div>
			<button
				class="mgs-previous-hole button mgs-button is-small block ml-auto"
				@click="$emit('go-to-next-hole')"
			>
				Next >
			</button>
		</div>

		<div class="mgs-hole-edit-container w-full">
			<hole-score-tracking
				v-if="!fetchingMeta"
				:shot-meta="shotMeta"
				:round-hole="hole"
				:golf-round="golfRound"
				@update-score="updateScore"
				@save-round="saveRound"
				@go-to-next-hole="$emit('go-to-next-hole')"
				@go-to-previous-hole="$emit('go-to-previous-hole')"
			/>
		</div>
	</div>
</template>
<script>
/** @format */
import holeMod from "./../../modules/hole";
import ApiService from "../../services/ApiService";

export default {
	name: "RoundHoleEdit",
	props: {
		golfRound: {
			type: Object,
			required: true
		},
		value: {
			type: Object,
			required: true
		}
	},
	components: {
		"course-fairway-select": () =>
			import(/* webpackChunkName: "CourseFairwaySelect" */ "./../Course/FairwaySelect"),
		"course-scramble-select": () =>
			import(/* webpackChunkName: "CourseScrambleSelect" */ "./../Course/ScrambleSelect"),
		"hole-score-tracking": () =>
			import(/* webpackChunkName: "HoleScoreTracking" */ "./HoleScoreTracking")
		//'course-tee-title': () => import(/* webpackChunkName: "CourseTeeTitle" */ './../Course/TeeTitle'),
		//'golf-score-graphic': () => import(/* webpackChunkName: "GolfScoreGraphic" */ './ScoreGraphic'),
	},
	methods: {
		scoreClasses(hole) {
			return holeMod.scoreClasses(hole);
		},
		updateScore(hole) {
			console.log('called');
			this.$emit("update-score", hole);
		},
		saveRound(hole) {
			this.updateScore(hole);
			console.log('save');
			this.$emit('save-round');
		},
		async fetchShotMeta() {
			this.fetchingMeta = true;
			const { data } = await ApiService.getShotMetaData();
			this.shotMeta = data.data;
			this.fetchingMeta = false;
		}
	},
	watch: {
		value(h) {
			this.hole = h;
			if (this.$refs.score) {
				this.$refs.score.focus();
			}
		}
	},
	data() {
		return {
			hole: this.value,
			fetchingMeta: true,
			shotMeta: {}
		};
	},
	mounted() {
		this.fetchShotMeta();
	}
};
</script>
<style lang="scss">
.mgs-hole-edit-container {
	h2 {
		@apply font-bold;
	}
	background: white;
	@apply p-4;
	.mgs-previous-hole {
		@apply bg-forest-green text-white my-1;
		border-radius: 6px;
	}
	.mgs-hole-edit {
		@apply text-xs my-1;
		div:first-child {
		}
		div:last-child {
			margin-left: auto;
		}
		select {
			width: 60px;
			margin-left: auto;
		}
		.mgs-scorecard-input {
			border-bottom: 1px solid;
			width: 100px;
		}
	}
}
</style>
